import { createListenCollectionEpic, createListenDocEpic } from 'src/firebase';
import { actions, actionTypes } from './redux';

const ListenCategoriesEpic$ = createListenCollectionEpic({
  collection: 'featuredCategories',
  listenType: actionTypes.LISTEN_COLLECTION,
  unlistenType: actionTypes.UNLISTEN_COLLECTION,
  changeCollection: actions.changeCollection,
});

const ListenFeaturedCategoryDetailEpic$ = createListenDocEpic({
  collection: 'featuredCategories',
  listenType: actionTypes.LISTEN_DOC,
  unlistenType: actionTypes.UNLISTEN_DOC,
  changeDoc: actions.changeDoc,
});

export {
  ListenCategoriesEpic$,
  ListenFeaturedCategoryDetailEpic$
};



// WEBPACK FOOTER //
// ./src/featuredCategories/epics.ts